import { FilterStructure } from '@shared/components/ui/AdvancedFilter';

export const getEligibleStorageFilterOptions = (t: (key: string) => string): FilterStructure[] => {
  return [
    {
      column: {
        label: t('table.date'),
        value: 'storage_date',
        type: 'date',
      },
      actions: [
        { label: t('filters.in'), value: 'in' },
        { label: t('filters.notIn'), value: 'not_in' },
        { label: t('filters.greaterThan'), value: 'greater_than' },
        { label: t('filters.lessThan'), value: 'less_than' },
        { label: t('filters.greaterEqual'), value: 'greater_equal' },
        { label: t('filters.lessEqual'), value: 'less_equal' },
      ],
      values: [],
    },
    {
      column: {
        label: t('table.units'),
        value: 'quantity',
        type: 'number',
      },
      actions: [
        { label: t('filters.equals'), value: 'equals' },
        { label: t('filters.greaterThan'), value: 'greater_than' },
        { label: t('filters.lessThan'), value: 'less_than' },
        { label: t('filters.greaterEqual'), value: 'greater_equal' },
        { label: t('filters.lessEqual'), value: 'less_equal' },
      ],
      values: null,
    },
    {
      column: {
        label: t('table.preinvoiceNumber'),
        value: 'preinvoice_id',
        type: 'number',
      },
      actions: [
        { label: t('filters.isNull'), value: 'is_null' },
        { label: t('filters.isNotNull'), value: 'is_not_null' },
        { label: t('filters.equals'), value: 'equals' },
      ],
      values: null,
    },
    {
      column: {
        label: t('table.invoiceNumber'),
        value: 'invoice_id',
        type: 'number',
      },
      actions: [
        { label: t('filters.isNull'), value: 'is_null' },
        { label: t('filters.isNotNull'), value: 'is_not_null' },
        { label: t('filters.equals'), value: 'equals' },
      ],
      values: null,
    },
    {
      column: {
        label: t('table.period'),
        value: 'period',
        type: 'select',
      },
      actions: [
        { label: t('filters.equals'), value: 'equals' },
        { label: t('filters.notEquals'), value: 'not_equals' },
        { label: t('filters.in'), value: 'in' },
        { label: t('filters.notIn'), value: 'not_in' },
        { label: t('filters.isNull'), value: 'is_null' },
        { label: t('filters.isNotNull'), value: 'is_not_null' },
      ],
      values: [
        { label: t('filters.periodOptions.weekly', 'Semanal'), value: 'WEEKLY' },
        { label: t('filters.periodOptions.monthly', 'Mensual'), value: 'MONTHLY' },
      ],
    },
  ];
};
